import React from "react";
import { Constants } from "../../CommonMethhods/Constants";
import { numDifferentiationWithoutSymbol } from "../../CommonMethhods/CovertRupees";
import LoaderForSearch from "../Common/LoaderForSearch";

function RevenueTableNew(props) {
  let gridVal = props?.gridVal;
  const handleScroll = props?.handleScroll;
  const scrollLoader = props?.scrollLoader;
  const totalValue = props.totalValue;
  
  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper ">
        {gridVal && gridVal ? (
          <table className="table last-column">
            <thead>
              <tr>
              <th scope="col" className="text-center">
                  Party Code
                </th>
              <th scope="col" className="text-center">
                  {Constants.client_Name}
                </th>
                <th scope="col" className="text-center">
                  Gross Brokerage Income
                </th>
                {/* <th scope="col" className="text-center">
                  Brokerage Reversal
                </th> */}
                {/* <th scope="col" className="text-center">
                  Net Brokerage
                </th> */}
                <th scope="col" className="text-center">
                  MTF ROI
                </th>
                {/* <th scope="col" className="text-center">
                  MTF INT
                </th> */}
                {/* <th scope="col" className="text-center">
                  MTF Reversal
                </th>
                <th scope="col" className="text-center">
                  NET MTF INT
                </th>
                <th scope="col" className="text-center">
                  DP Income
                </th>
                <th scope="col" className="text-center">
                  DP Reversal
                </th>
                <th scope="col" className="text-center">
                  NET DP INC
                </th>
                <th scope="col" className="text-center">
                  NET Income
                </th>
                <th scope="col" className="text-center">
                  DPC ROI
                </th>
                <th scope="col" className="text-center">
                  DPC INT
                </th>
                <th scope="col" className="text-center">
                  DPC Reversal
                </th>
                <th scope="col" className="text-center">
                  NET DPC
                </th> */}
                {/* <th scope="col" className="text-center">
                  NET Branch INC
                </th> */}
                <th scope="col" className="text-center">
                  Branch
                </th>
                <th scope="col" className="text-center">
                  RM Name
                </th>
                <th scope="col" className="text-center">
                  Dealer Name
                </th>
              </tr>
            </thead>
            <tbody id="clientrevenue-scroll" onScroll={handleScroll}>
              {gridVal &&
                gridVal.map((item, key) => {
                  return (
                    <tr key={key}>
                    <td>{item?.partyCode || "-"}</td>
                      <td>{item?.clientName || "-"}</td>
                      <td>{item?.grossBrokerageIncome || 0}</td>
                      {/* <td>{item?.brokerageReversal || 0}</td> */}
                      {/* <td>{item?.netbrokerage || 0}</td> */}
                      <td>{item?.mtfRoi || 0}</td>
                      {/* <td>{item?.mtfint || 0}</td> */}
                      {/* <td>{item?.mtfReversal || 0}</td>
                      <td>{item?.netMtfInt || 0}</td>
                      <td>{item?.dpIncome || 0}</td>
                      <td>{item?.dpReversal || 0}</td>
                      <td>{item?.netDpInc || 0}</td>
                      <td>{item?.netIncome || 0}</td>
                      <td>{item?.dpcRoi || 0}</td>
                      <td>{item?.dpcInt || 0}</td>
                      <td>{item?.dpcReversal || 0}</td>
                      <td>{item?.netDpc || 0}</td> */}
                      {/* <td>{item?.netBranchInc || 0}</td> */}
                      <td>{item?.branch || "-"}</td>
                      <td>{item?.rmName || "-"}</td>
                      <td>{item?.dealerName || "-"}</td>

                    </tr>
                  );
                })}
              {scrollLoader && (
                <div className="loader-center">
                  <LoaderForSearch />
                </div>
              )}
            </tbody>
              <tbody className="totalRevnueData">
                <tr>
                  <td>Total</td>
                  <td></td>
                  <td>
                    {totalValue?.totalBrokerageIncome || 0}
                  </td>
                  {/* <td>
                    {totalValue?.totalBrokerageReversal || 0}
                  </td> */}
                  {/* <td>
                    {totalValue?.totalNetbrokerage || 0}
                  </td> */}
                  <td>
                    {totalValue?.totalMtfRoi || 0}
                  </td>
                  {/* <td>
                    {totalValue?.totalMtfint || 0}
                  </td> */}
                  {/* <td>
                    {totalValue?.totalMtfReversal || 0}
                  </td>
                  <td>
                    {totalValue?.totalNetMtfInt || 0}
                  </td>
                  <td>
                    {totalValue?.totalDpIncome || 0}
                  </td>
                  <td>
                    {totalValue?.totalDpReversal || 0}
                  </td>
                  <td>
                    {totalValue?.totalNetDpInc || 0}
                  </td>
                  <td>
                    {totalValue?.totalNetIncome || 0}
                  </td>
                  <td>
                    {totalValue?.totalDpcRoi || 0}
                  </td>
                  <td>
                    {totalValue?.totalDpcInt || 0}
                  </td>
                  <td>
                    {totalValue?.totalDpcReversal || 0}
                  </td>
                  <td>
                    {totalValue?.totalNetDpc || 0}
                  </td> */}
                  {/* <td>
                    {totalValue?.totalNetBranchInc || 0}
                  </td> */}
                  <td></td>
                  <td></td>
                  <td></td>

                </tr>
              </tbody>
          </table>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
export default RevenueTableNew;
